import React from "react"

import { StandAloneSongListItem } from "./StandAloneSongListItem"
import { StandAloneSongListItemExpanded } from "./StandAloneSongListItemExpanded"
import { AlbumListItem } from "./AlbumListItem"
import { VideoListItem } from "./VideoListItem"
import { HeadlineListItem } from "./HeadlineListItem"
import { ConcertListItem } from "./ConcertListItem"
import ConcertListItemExpanded from "./ConcertListItemExpanded"
import { AlbumListItemExpanded } from "./AlbumListItemExpanded"
import { VideoListItemExpanded } from "./VideoListItemExpanded"
import { HeadlineListItemExpanded } from "./HeadlineListItemExpanded"
import PlaylistListItem from "./PlaylistListItem"

import { mutationRequest } from "../../util/request"
import { EditorialListItemExpanded } from "./EditorialListItemExpanded"
import { EditorialListItem } from "./EditorialListItem"
import PlaylistListItemExpanded from "./PlaylistListItem/Expanded"

export class PostListItem extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isExpanded: props.expanded,
      post: props.post,
      adminMode: props.adminMode,
    }
  }

  get isPostPage() {
    return !!this.props.isPostPage
  }

  setIsExpanded = (isExpanded) => {
    this.setState({ isExpanded: isExpanded })
  }

  setPostListItem = (newPostListItem) => {
    this.setState({ post: newPostListItem })
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (
      nextState.isExpanded !== this.state.isExpanded ||
      nextState.post !== this.state.post ||
      nextProps.adminMode !== this.props.adminMode
    ) {
      return true
    } else {
      return false
    }
  }

  async updateStatus() {
    const post = this.state.post
    try {
      if (post.status === "published") {
        const response = await mutationRequest({
          path: `/api/v1/bands/${post.band_id}/posts/${post.id}`,
          options: { method: "DELETE" },
        })
        if (response.success) {
          this.setState({ post: { ...post } })
        }
      } else {
        const response = await mutationRequest({
          path: `/api/v1/bands/${post.band_id}/posts/${post.id}`,
          options: { method: "PUT" },
          data: {
            post: { status: "published" },
          },
        })
        if (response.success) {
          this.setState({ post: { ...post } })
        }
      }
    } catch (error) {
      console.error("ERROR: ", error)
    }
  }

  render() {
    return this.state.post ? (
      <li
        id={this.state.post.id}
        data-post-type={this.state.post.post_type}
        className={`mb-10 ${this.state.post.class_name}`}
      >
        {this.state.post.post_type === "album" ? (
          this.state.isExpanded ? (
            <AlbumListItemExpanded
              album={this.state.post}
              updateStatus={this.updateStatus.bind(this)}
              adminMode={this.state.adminMode}
              isPostPage={this.isPostPage}
            />
          ) : (
            <AlbumListItem
              album={this.state.post}
              updateStatus={this.updateStatus.bind(this)}
              adminMode={this.state.adminMode}
            />
          )
        ) : ["song", "stand_alone_song", "link_song"].includes(
            this.state.post.post_type,
          ) ? (
          this.state.isExpanded ? (
            <StandAloneSongListItemExpanded
              song={this.state.post}
              updateStatus={this.updateStatus.bind(this)}
              adminMode={this.state.adminMode}
              isPostPage={this.isPostPage}
            />
          ) : (
            <StandAloneSongListItem
              song={this.state.post}
              updateStatus={this.updateStatus.bind(this)}
              adminMode={this.state.adminMode}
            />
          )
        ) : ["youtube_video", "link_video"].includes(
            this.state.post.post_type,
          ) ? (
          this.state.isExpanded ? (
            <VideoListItemExpanded
              video={this.state.post}
              updateStatus={this.updateStatus.bind(this)}
              adminMode={this.state.adminMode}
              isPostPage={this.isPostPage}
            />
          ) : (
            <VideoListItem
              video={this.state.post}
              updateStatus={this.updateStatus.bind(this)}
              adminMode={this.state.adminMode}
            />
          )
        ) : ["concert", "event"].includes(this.state.post.post_type) ? (
          this.state.isExpanded ? (
            <ConcertListItemExpanded
              concert={this.state.post}
              setPostListItem={this.setPostListItem}
              updateStatus={this.updateStatus.bind(this)}
              adminMode={this.state.adminMode}
              isPostPage={this.isPostPage}
            />
          ) : (
            <ConcertListItem
              concert={this.state.post}
              isExpanded={this.state.isExpanded}
              setPostListItem={this.setPostListItem}
              updateStatus={this.updateStatus.bind(this)}
              adminMode={this.state.adminMode}
            />
          )
        ) : ["headline", "image_album", "link", "link_image"].includes(this.state.post.post_type) ? (
          this.state.isExpanded ? (
            <HeadlineListItemExpanded
              headline={this.state.post}
              updateStatus={this.updateStatus.bind(this)}
              adminMode={this.state.adminMode}
              isPostPage={this.isPostPage}
            />
          ) : (
            <HeadlineListItem
              headline={this.state.post}
              updateStatus={this.updateStatus.bind(this)}
              adminMode={this.state.adminMode}
            />
          )
        ) : ["bn_editorial"].includes(this.state.post.post_type) ? (
          this.state.isExpanded ? (
            <EditorialListItemExpanded
              post={this.state.post}
              updateStatus={this.updateStatus.bind(this)}
              isPostPage={this.isPostPage}
            />
          ) : (
            <EditorialListItem
              post={this.state.post}
              updateStatus={this.updateStatus.bind(this)}
            />
          )
        ) : ["playlist"].includes(this.state.post.post_type) ? (
          this.state.isExpanded ? (
            <PlaylistListItemExpanded
              playlist={this.state.post}
              updateStatus={this.updateStatus.bind(this)}
              isPostPage={this.isPostPage}
            />
          ) : (
            <PlaylistListItem
              playlist={this.state.post}
              updateStatus={this.updateStatus.bind(this)}
            />
          )
        ) : (
          <UnsupportedPostType post={this.state.post} />
        )}
      </li>
    ) : null
  }
}

const UnsupportedPostType = ({ post }) => {
  return <div></div>
}
